import React, { useRef, useState } from "react";
import { Divider, Tab, Tabs } from "@monolith-forensics/monolith-ui";
import moment from "moment";
import StorageReportMetrics from "./StorageReportMetrics";
import StorageSavedReports from "./StorageSavedReports";
import StorageReportComposition from "./StorageReportComposition";
import { Card } from "@mui/material";
import { EditReportPopup } from "../../EditReportPopup";
import StorageItemGrid from "./StorageItemGrid.js";
import ReportParametersPanel, {
  STORAGE_PARAMS_FIELDS,
} from "../ReportParametersPanel";

export const storageDimensions = [
  {
    text: "New Items",
    value: "Date Created",
    index: 0,
  },
  {
    text: "Assigned",
    value: "Date Assigned",
    index: 1,
  },
  {
    text: "Released",
    value: "Date Released",
    index: 2,
  },
];

const ReportDetails = ({ reportInfo }) => {
  return (
    <Card
      style={{
        padding: "20px",
        textAlign: "left",
        flexGrow: 1,
        marginRight: 15,
      }}
    >
      <div
        style={{
          fontSize: "larger",
        }}
      >
        Report Details
      </div>
      <Divider style={{ margin: "16px 0" }} />
      <div
        style={{
          minWidth: "300px",
        }}
      >
        {reportInfo.report_id && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Report ID: </div>
            <div>{reportInfo.report_id}</div>
          </div>
        )}
        {reportInfo.name && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Report Name: </div>
            <div>{reportInfo.name}</div>
          </div>
        )}
        {reportInfo.created_at && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Created On:</div>
            <div>{moment(reportInfo.created_at).format("MMMM DD, YYYY")}</div>
          </div>
        )}
        {reportInfo.created_by && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Created By: </div>
            <div>{reportInfo.created_by}</div>
          </div>
        )}
        {reportInfo.category && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "5px",
            }}
          >
            <div>Category: </div>
            <div>{reportInfo.category}</div>
          </div>
        )}
      </div>
    </Card>
  );
};

const TabSection = ({ reportInfo }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div style={{ minHeight: "450px" }}>
      <Tabs value={selectedTab} onChange={setSelectedTab}>
        <Tab value={0}>Saved Reports</Tab>
        <Tab value={1}>Storage Items</Tab>
      </Tabs>
      {selectedTab === 0 && <StorageSavedReports reportInfo={reportInfo} />}
      {selectedTab === 1 && <StorageItemGrid reportInfo={reportInfo} />}
    </div>
  );
};

const StorageReport = ({ reportInfo, setFormUpdated }) => {
  const editReportPopup = useRef(null);

  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "20px",
        }}
      >
        <ReportDetails reportInfo={reportInfo} />
        <ReportParametersPanel
          reportInfo={reportInfo}
          editReportPopup={editReportPopup}
          filterFields={STORAGE_PARAMS_FIELDS}
        />
        <StorageReportMetrics reportInfo={reportInfo} />
      </div>
      <StorageReportComposition reportInfo={reportInfo} />
      <TabSection reportInfo={reportInfo} />
      <EditReportPopup
        editReportPopup={editReportPopup}
        reportInfo={reportInfo}
        setFormUpdated={setFormUpdated}
      />
    </>
  );
};

export default StorageReport;
